import { Suspense, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs";
import Search from "../../../components/Search";
import { User } from "../../../models";
import { fetchUsersPages } from "./data";
import Pagination from "../../../components/pagination";
import { PaginationResult } from "../../../lib/definitions";
import UsersTableSkeleton from "./ui/skeletons/usersTableSkeleton";
import UsersTable from "./ui/usersTable";

export default function UsersPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query") || "";
  const currentPage = Number(searchParams.get("page")) || 1;
  const ITEMS_PER_PAGE = 6;
  const [users, setUsers] = useState<PaginationResult<User>>({
    items: [],
    page: currentPage,
    pageSize: ITEMS_PER_PAGE,
    totalCount: 0,
    hasNextPage: false,
    hasPreviousPage: false,
    totalPages: 0,
  });
  useEffect(() => {
    async function fetchUsers() {
      try {
        console.log("Fetching users with query:", query, "and page:", currentPage);
        const fetchedUsers = await fetchUsersPages(currentPage, ITEMS_PER_PAGE, query);
        setUsers(fetchedUsers);
        console.log("Fetched Users:", fetchedUsers);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchUsers();
  }, [query, currentPage]);
  console.log("UsersPage rendered with query:", query, "and currentPage:", currentPage);
  //const users = await fetchUsersPages(query);
  //console.log("UsersPage", query, currentPage);
  return (
    <div className="w-full">
      <Breadcrumbs
        breadcrumbs={[{ label: "Users", href: "/admin/users", active: true }]}
      />
      <div className="mt-4 flex items-center justify-between gap-2 md:mt-8">
        <Search placeholder="Search users..." />
      </div>
      <Suspense key={query + currentPage} fallback={<UsersTableSkeleton />}>
        <UsersTable users={users} />
      </Suspense>
      <div className="mt-5 flex w-full justify-center">
        <Pagination totalPages={users.totalPages} />
      </div>
    </div>
  );
}
